import { styled } from '../theme';
import Text from './Text';

const Small = styled(Text)(({ theme }) => ({
    color: theme.color.gray70,
    fontSize: '1.3rem',
}));

export default Small;
